export default "__VITE_ASSET__BlcCuZid__"